module.exports = __webpack_public_path__ + "img/Delete-grey.04e1fc93.svg";